import moment from "moment";

export default {
  methods: {
    isScriptTag(text) {
      const regex = /<script\b[^>]*>[\s\S]*?<\/script\b[^>]*>/g;
      return text && text.match(regex) ? true : false;
    },
    detectUrlString(str) {
      var urlRegex= new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?([^ ])+");
      return str && str.match(urlRegex) ? true : false;
    },
    getDateBefore(dayNumber) {
      const currDate = new Date();
      return new Date(currDate.getTime() - dayNumber * 24 * 60 * 60 * 1000);
    },
    getDisplayTime(sentAt) {
      if(!sentAt) {
        return;
      }
      const time = new Date(sentAt).setHours(0, 0, 0, 0);
      if (time >= this.getDateBefore(1).getTime()) {
        return moment(sentAt).local().format("HH:mm");
      } else if (time >= this.getDateBefore(2).getTime()) {
        return this.$t("chat-yesterday-label");
      } else {
        return moment(sentAt).local().format("DD/MM/YYYY");
      }
    },
  },
};
